<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" style="margin-right: 10px" @click="$refs.created.openDialog()">新 增</el-button>
      <el-input v-model="tableQuery.name" style="width: 200px;" @change="selectPage" placeholder="请输入规则名称"></el-input>
    </div>
    <el-table border class="table" :data="tableData" height="600px" v-loading="tableQuery.loading" empty-text="空空如也～ 新增一条吧！">
      <el-table-column prop="name" label="名称" width="220"/>
      <el-table-column label="获取积分" width="160">
        <template #default="scope">
          {{scope.row.score}}积分
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="关联审批模板Id" width="240">
        <template #default="scope">
          {{scope.row.templateId}}
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="有效日期" width="360">
        <template #default="scope">
          {{scope.row.startTime}} ~ {{scope.row.endTime}}
        </template>
      </el-table-column>
      <el-table-column prop="rule" label="规则说明" show-overflow-tooltip/>
      <el-table-column
          prop="addTime"
          label="创建日期"
          width="180">
      </el-table-column>
      <el-table-column label="操作" width="110" align="center">
        <template #default="scope">
          <div style="margin-right: 4px;">
            <el-button type="text" size="small" style="margin-right: 10px" @click.prevent="updateItem(scope.row)">编辑</el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <el-button slot="reference" type="text" size="small" style="color: red;">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.total">
    </el-pagination>
    <created-rule @refresh="selectPage" ref="created"/>
    <update-rule @refresh="selectPage" ref="update"/>
  </div>
</template>

<script>
import CreatedRule from "./CreatedRule";
import UpdateRule from "./UpdateRule";
import {selectPointsRuleByPage,deletePointsRule} from '/src/api/contacts/hr/pointCard.js'
export default {
  name: "SetRule",
  components:{
    CreatedRule,UpdateRule
  },
  data() {
    return {
      tableData:[],
      tableQuery:{
        name:"",
        pageIndex:0,
        pageSize:11,
        loading:false,
        total:0
      }
    }
  },
  methods:{
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectPage();
    },
    selectPage(){
      this.tableQuery.loading = true;
      selectPointsRuleByPage(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          this.tableData = val.data.list;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    updateItem(item){
      this.$refs.update.openDialog(item);
    },
    deleteItem(id){
      deletePointsRule(id).then(val => {
        if (val.status){
          this.selectPage();
          this.$notify.success({title: '提示', message: '删除成功！', offset: 40});
        }else {
          this.$notify.error({title: '删除失败！', message: val.data, offset: 40});
        }
      })
    }
  },
  created() {
    this.selectPage();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
</style>